import React, { MouseEvent, useState } from 'react';

import { Button, Warning } from './IDSK';

type ConfirmationProps = {
    label: React.ReactNode;
    children: React.ReactNode;
    onConfirm: () => void;
    onReject?: () => void;
    className?: string;
};

export default function Confirmation(props: ConfirmationProps) {
    const [showModal, setShowModal] = useState(false);

    const preventClicks = (e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const onClick = (e: MouseEvent) => {
        preventClicks(e);
        setShowModal(true);
    };

    const onReject = () => {
        setShowModal(false);

        if(props.onReject) {
            props.onReject();
        }
    };

    const onConfirm = () => {
        setShowModal(false);
        props.onConfirm();
    };

    return <>
        <div className={`chat--confirmation ${props.className}`} onClick={onClick}>
            {props.children}
        </div>

        {showModal && <div className="chat--confirmation--modal" onClick={preventClicks}>
            <div className="chat--confirmation--modal--content">
                <Warning>{props.label}</Warning>

                <div className="chat--confirmation--modal--controls">
                    <Button variant="secondary" onClick={onReject}>Späť</Button>
                    <Button onClick={onConfirm}>Potvrdiť</Button>
                </div>
            </div>
        </div>}
    </>;
}
